import { Button, Box, Tooltip } from '@mui/material';
import Preloader from 'components/Preloader';
import { useTranslation } from 'react-i18next';
import EmptyMenu from 'components/MenuNew/EmptyMenu';
import { HeaderContainer, StripedDataGrid } from '../styles';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { MODE, MUI_TO_SX_STYLES } from 'pages/TableOrdering/config';
import TableOrderModal from 'pages/TableOrdering/Tables/TableOrderModal';
import CreateOrEditForm from 'pages/TableOrdering/Jobs/CreateOrEditForm';
import { useTableOrderingJobs } from 'pages/TableOrdering/hooks/useTableOrderingJobs';
import usePermission from 'hooks/permission';
import * as all from 'constants/permissions';

const Jobs = () => {
  const { t } = useTranslation();
  const checkPermission = usePermission();
  const isSuperAdmin = checkPermission(all['SUPER']);
  const {
    jobsFilter,
    jobColumns,
    setOpen,
    open,
    mode,
    formMethods,
    handleSubmit,
    handleCancel,
    currentPayBasis,
    handleChangePayBasis,
    currentTipped,
    handleChangeTipped,
    currentCashier,
    handleChangeCashier,
    currentDriver,
    handleChangeDriver,
    lastCreatedJob,
    setRowsPerPage,
    rowsPerPage,
    loading,
  } = useTableOrderingJobs();

  return (
    <Box>
      <HeaderContainer>
        {!isSuperAdmin ? (
          <Tooltip title={'Contact support to add new job'} placement="top">
            <span>
              <Button
                id="tablesAddTable"
                onClick={() => {}}
                variant="contained"
                color="primary"
                type="button"
                className={`${open ? 'disabledButton' : ''}`}
                startIcon={<AddOutlinedIcon />}
                disabled
              >
                {t('table_ordering.new_jobs')}
              </Button>
            </span>
          </Tooltip>
        ) : (
          <Button
            id="tablesAddTable"
            onClick={() => setOpen(true)}
            variant="contained"
            color="primary"
            type="button"
            className={`${open ? 'disabledButton' : ''}`}
            startIcon={<AddOutlinedIcon />}
          >
            {t('table_ordering.new_jobs')}
          </Button>
        )}
      </HeaderContainer>
      <TableOrderModal
        open={open}
        handleClose={handleCancel}
        title={
          mode === MODE.CREATE
            ? t('table_ordering.new_jobs')
            : t('table_ordering.edit_jobs')
        }
        disabled={
          !formMethods.formState.isDirty || !formMethods.formState.isValid
        }
        saveTitle={
          mode === MODE.CREATE
            ? t('table_ordering.new_jobs')
            : t('table_ordering.save')
        }
        cancelTitle={'Cancel'}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        loading={loading}
      >
        <CreateOrEditForm
          mode={mode}
          currentPayBasis={currentPayBasis}
          handleChangePayBasis={handleChangePayBasis}
          currentTipped={currentTipped}
          handleChangeTipped={handleChangeTipped}
          currentCashier={currentCashier}
          handleChangeCashier={handleChangeCashier}
          currentDriver={currentDriver}
          handleChangeDriver={handleChangeDriver}
        />
      </TableOrderModal>
      <StripedDataGrid
        sx={MUI_TO_SX_STYLES}
        autoHeight={true}
        hideFooterSelectedRowCount={true}
        isEditable={false}
        hideFooter={true}
        getRowClassName={(params) =>
          params?.row?.id === lastCreatedJob
            ? 'highlight_last-selected_item'
            : ''
        }
        rowsPerPageOptions={[100]}
        pageSize={rowsPerPage}
        onPageSizeChange={(newPageSize) => setRowsPerPage(newPageSize)}
        rows={jobsFilter}
        columns={jobColumns}
        components={{
          LoadingOverlay: Preloader,
          NoRowsOverlay: () => (
            <Box sx={{ mt: '100px' }}>
              <EmptyMenu text={t('There are no jobs yet')} />
            </Box>
          ),
        }}
        loading={loading}
      />
    </Box>
  );
};
export default Jobs;
